import React, { useState } from 'react'
import Header from '../../Layout/Header'
import Footer from '../../Layout/Footer'

function CareerDetails() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    salary: '',
    message: ''
  });
  const [resumeFile, setResumeFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setResumeFile(e.target.files && e.target.files[0] ? e.target.files[0] : null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitStatus(null);

    try {
      // Using FormData (multipart) rather than urlencoded here so the resume
      // file can actually be attached alongside the text fields.
      const body = new FormData();
      body.append('action', 'ADD');
      body.append('name', formData.name);
      body.append('email', formData.email);
      body.append('phone', formData.phone);
      body.append('company_url', 'retailer.mokshiq.in');
      body.append('subject', 'Career Application: Technical Project Manager');
      body.append(
        'message',
        `${formData.message}\n\nAddress: ${formData.address}\nExpected Salary: ${formData.salary}\nApplied For: Technical Project Manager (Full-Time)`
      );
      if (resumeFile) {
        body.append('resume', resumeFile);
      }

      const response = await fetch('https://api.mokshiq.in/enquiry-action', {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoyMDg1LCJjbGllbnRfaWQiOiJjc2Mua3J5bnRpcS5jb20iLCJqdGkiOiIzN2EwNjYyYi04NDg1LTQ0YWUtOTg0ZS03ZjNhOWZiYzMzYjgiLCJpYXQiOjE3ODc0MDA3MTUsImV4cCI6MjEwMjc2MDcxNX0.EhMHAZw7sXm1Q6TCtRlryqBDTwQ68XSHMOq_MQ3B-kk'
        },
        body: body
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', address: '', salary: '', message: '' });
        setResumeFile(null);
        const fileInput = document.getElementById('file-upload');
        if (fileInput) fileInput.value = '';
      } else {
        setSubmitStatus('error');
      }
    } catch (err) {
      setSubmitStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  // Defensive inline styles so typed text always stays dark/legible
  // regardless of any global/dark-theme CSS on this page.
  const fieldStyle = { color: '#0f172a', caretColor: '#0f172a' };

  // FIX: The "Career Details" content section sits on a dark background,
  // but headings/paragraphs/list text were using the `text-dark` class,
  // which made them nearly invisible (dark text on dark background).
  // These inline styles force light, readable text regardless of any
  // global/dark-theme CSS conflicts.
  const headingStyle = { color: '#ffffff' };
  const bodyTextStyle = { color: '#e2e8f0' };
  const labelStrongStyle = { color: '#ffffff' };
  const iconStyle = { color: '#22c55e' };

  return (
    <div className="page_wrapper">
        <Header/>
         <main className="page_content">


<section className="page_header text-center bg-dark section_decoration overflow-hidden" style={{backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')"}}>
  <div className="container">
    <h1 className="page_title text-white">Career Details</h1>
    <ul className="breadcrumb_nav unordered_list justify-content-center">
      <li><a href="index.html">Home</a></li>
      <li className="active"><a href="#!">Career Details</a></li>
    </ul>
  </div>
  <div className="decoration_item shape_nate">
    <img src="assets/images/shapes/shape_nate.svg" alt="Shape Nate"/>
  </div>
  <div className="decoration_item shape_dollar_1 wow fadeInUp" data-wow-delay=".2s">
    <img src="assets/images/shapes/shape_dollar_1.webp"  data-parallax='{"y" : 100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div className="decoration_item shape_dollar_2 wow fadeInUp" data-wow-delay=".2s">
    <img src="assets/images/shapes/shape_dollar_2.webp" data-parallax='{"y" : 100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div className="decoration_item shape_dollar_3 wow fadeInUp" data-wow-delay=".3s">
    <img src="assets/images/shapes/shape_dollar_3.webp" data-parallax='{"y" : -100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div className="decoration_item shape_dollar_4 wow fadeInUp" data-wow-delay=".3s">
    <img src="assets/images/shapes/shape_dollar_4.webp" data-parallax='{"y" : -100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div className="decoration_item shape_pattern_1">
    <img src="assets/images/shapes/breadcrumb_shape_pattern_1.svg" alt="Shape Pattern"/>
  </div>
  <div className="decoration_item shape_pattern_2">
    <img src="assets/images/shapes/breadcrumb_shape_pattern_2.svg" alt="Shape Pattern"/>
  </div>
</section>

<section className="career_details_section section_space pb-0">
  <div className="container">
    <div className="item_details_content">
      <h2 className="item_details_info_heading mt-0" style={headingStyle}>Technical Project Manager - (Full-Time)</h2>
      <ul className="iconlist_block unordered_list_block mb-4">
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>Department:</strong> Technical Project Manager
          </span>
        </li>
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>No. of Openings:</strong> (3)
          </span>
        </li>
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>Job Type:</strong> Full-Time
          </span>
        </li>
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>Location:</strong> Warsaw, Poland
          </span>
        </li>
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>Salary range:</strong> $80k to $100k (Based on your experience).
          </span>
        </li>
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>Working days:</strong> Weekly 05 days. Sunday To Thursday. 09 AM to 06 PM.(Launch Break 01 Hour)
          </span>
        </li>
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>Application Deadline:</strong> November 10, 2024
          </span>
        </li>
        <li>
          <span className="iconlist_text" style={bodyTextStyle}>
            <strong style={labelStrongStyle}>Experience Required:</strong> 5+ Years
          </span>
        </li>
      </ul>
      <p style={bodyTextStyle}>
        We’re looking for a Technical Project Manager and knowledgeable Product Designer to join our technical team in Warsaw, Poland. You’ll be expected to utilize bleeding-edge technology and robust techniques. You should be an excellent communicator and comfortable managing multiple tasks. you also need to be a team player and have a problem-solving aptitude.
      </p>
      <p style={bodyTextStyle}>
        Working quickly and creatively should come naturally to you, as well as being an innovative problem-solver who takes pride in producing logical, simple, and effective solutions to what are often very new and complex issues.
      </p>

      <h3 className="item_details_info_heading" style={headingStyle}>What you'll get to do...</h3>
      <ul className="iconlist_block unordered_list_block mb-4">
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Refactor current code to service-oriented architecture
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Collaborate with a unique background of engineering, product, and operations team members to deliver the best solution for our customers
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Solve technical problems that few have solved before – no one else helps local businesses the way we do
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Participate in the decision-making progress – we want you to speak up
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Mentor your team members to share your passion for software, your appreciation for engineering field, and your respect.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Take on the challenge of making what you build higher quality, faster, and more scalable
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Participate in on-call rotation
          </span>
        </li>
      </ul>

      <h3 className="item_details_info_heading" style={headingStyle}>Your experience should include...</h3>
      <ul className="iconlist_block unordered_list_block mb-4">
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            6+ years of previous professional Proficient Project Management experience
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Technical Expertise: Solid understanding for effective communication.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Stakeholder Management: Track record of ensuring alignment and success.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Agile Methodologies: Hands-on experience in Agile frameworks.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Risk Management: Skill in identifying and mitigating project risks.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Team Leadership: Ability to motivate diverse teams.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Communication Skills: Strong ability to convey technical concepts.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Problem-Solving: Proactive approach to implement solutions.
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Quality Assurance: Experience in ensuring deliverable standards.
          </span>
        </li>
      </ul>

      <h3 className="item_details_info_heading" style={headingStyle}>You might also have...</h3>
      <ul className="iconlist_block unordered_list_block mb-4">
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Experience with AWS
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Experience building CI/CD and server/deployment automation solutions
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Experience with open-source puppet, infrastructure-as-code
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Passion for technology
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            You have high standards and want to make a difference with your work
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            You are always trying to improve
          </span>
        </li>
      </ul>

      <h3 className="item_details_info_heading" style={headingStyle}>Great Benefits...</h3>
      <ul className="iconlist_block unordered_list_block">
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Company-wide 401(k) plan
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Life & disability insurance offered
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Competitive compensation—salary, bonus, equity
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Medical, dental, and vision; flex spending account
          </span>
        </li>
        <li>
          <span className="iconlist_icon" style={iconStyle}>
            <i className="fa-solid fa-circle"></i>
          </span>
          <span className="iconlist_text" style={bodyTextStyle}>
            Flexible paid time off & sick leave
          </span>
        </li>
      </ul>
    </div>
  </div>
</section>

<section className="job_apply_section section_space">
  <div className="container">
    <div className="job_apply_form">
      <div className="heading_block">
        <h3 className="heading_text" style={headingStyle}>
          Apply for This Job
        </h3>
        <p className="heading_description mb-0" style={bodyTextStyle}>
          Synox doesn’t accept unsolicited resumes from recruiters or employment agencies.
        </p>
      </div>

      {submitStatus === 'success' && (
        <div className="alert alert-success py-2 small mb-3" role="alert">
          <i className="fa-solid fa-circle-check me-2"></i>
          Thank you! Your application has been submitted successfully. Our HR team will get back to you soon.
        </div>
      )}
      {submitStatus === 'error' && (
        <div className="alert alert-danger py-2 small mb-3" role="alert">
          <i className="fa-solid fa-triangle-exclamation me-2"></i>
          Something went wrong while submitting your application. Please try again.
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label className="input_title" htmlFor="input_name" style={labelStrongStyle}>Name<sup>*</sup></label>
              <input
                id="input_name"
                className="form-control"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Carlo Castillo"
                required
                style={fieldStyle}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="input_title" htmlFor="input_email" style={labelStrongStyle}>Email<sup>*</sup></label>
              <input
                id="input_email"
                className="form-control"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="alma.lawson@example.com"
                required
                style={fieldStyle}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="input_title" htmlFor="input_tel" style={labelStrongStyle}>Phone<sup>*</sup></label>
              <input
                id="input_tel"
                className="form-control"
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+88 (0) 101 0000 000"
                required
                style={fieldStyle}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="input_title" htmlFor="input_address" style={labelStrongStyle}>Address<sup>*</sup></label>
              <input
                id="input_address"
                className="form-control"
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Warsaw, Poland"
                required
                style={fieldStyle}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label className="input_title" htmlFor="input_salary" style={labelStrongStyle}>What is your expected salary?<sup>*</sup></label>
              <input
                id="input_salary"
                className="form-control"
                type="text"
                name="salary"
                value={formData.salary}
                onChange={handleChange}
                placeholder="$1,000 - $3,000"
                required
                style={fieldStyle}
              />
            </div>
            <div className="form-group">
              <label className="input_title" htmlFor="input_message" style={labelStrongStyle}>Cover Letter<sup>*</sup></label>
              <textarea
                id="input_message"
                className="form-control"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write about your self..."
                required
                style={fieldStyle}
              ></textarea>
            </div>
            <div className="form-group-file">
              <label htmlFor="file-upload" className="file-upload-label" style={labelStrongStyle}>
                Resume / CV
              </label>
              <input id="file-upload" type="file" accept=".pdf, .doc, .jpg" onChange={handleFileChange}/>
              <span className="accepted_file_types" style={bodyTextStyle}><strong style={labelStrongStyle}>Accepted file types:</strong> pdf, doc, jpg, Max. file size: 15 MB.</span>
            </div>
            <button className="btn text-dark" type="submit" disabled={submitting}>
              <span className="btn_label">{submitting ? 'Submitting...' : 'Submit Now'}</span>
              <span className="btn_icon"><svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9H19V7H0V9Z" fill="#012A2B" />
              </svg></span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>


</main>
<Footer/>
    </div>
  )
}

export default CareerDetails